import React from "react";
import { Urls,Paths } from "../../constants/UrlConstants";
import Content from "../../content/Content";
import SmartLink from "../../../src/components/shared/links/SmartLink";
import style from "../../assets/css/modules/shared/promo-image-card.css";
import { Link } from "react-router-dom";
import layoutStyle from "../../assets/css/modules/shared/layout.css";

const QueryForHBS = {
  label: "Please select the type of condition this claim is for",
  option1Label: "Muscle, bone or joint problem",
  option1Content:
  (
  <React.Fragment>
  Get the help you need; we’ve made sure you can speak to an expert fast and without a GP referral.
  </React.Fragment>
  ),
  option1ContentLargeCorp:
  (
  <React.Fragment>
  <div>Get the help you need; we’ve made sure you can speak to an expert fast and without a GP referral</div>
  <div className="hbsLargeCorp">
  Most of our members have access to this service, please check your employer has selected the muscle, 
  bones and joints digital service by referring to the Working Body section in your handbook, 
  which you can find <Link
          className={"hol-link " + layoutStyle.anchorDecorationUnderline}
          to={Paths.Cover}>
          here
        </Link>
        .
  </div>
  </React.Fragment>
  ),
  option1IconClass: "icon-plaster-crutch-outline",
  option2Label: "other conditions",
  option2Content:
    "Claim for a treatment or appointment related to any condition other than muscles, bones or joints",
  option2IconClass: "icon-critical-illness",
  isThePatientHeader:
    "Thanks, here’s how to get started:",
  isThePatientBody: (
    <React.Fragment>  
     <div>
      <ul className="hbsUpperContent">
      <li className="liHbs">We’re working with HBSUK, a specialist-led online service that is part of the AXA Group. When booking your first appointment with HBSUK, select the AXA Health login and use your AXA Health membership number, found on your membership documents.</li>
      <li className="liHbs">Fill in a few details about your symptoms, and you’ll be offered an appointment with a physiotherapist, an advanced physiotherapist, or a specialist, based on the information you give us.</li> 
      <li className="liHbs">Select a video or phone appointment at a time that suits you (appointments are available Monday to Friday 8am to 8pm). They’ll talk through your symptoms, assess you and work out what could be wrong.</li>
      <li className="liHbs">They’ll then guide you to the next steps – that could be self-help exercises at home, or further treatment<sup>1</sup>.</li>
      </ul>
      </div>
      
      <div className="hbsClass">
      <ol type = "1">
      <li className="liHbs">You'll need the appropriate benefits for any face-to-face consultations, tests or treatment and any benefit limits or contribution you normally make towards treatment costs each year will apply. We recommend you contact us before arranging any tests or face-to-face treatment so we can check your membership will cover the cost.</li>
      </ol>
      </div>
      <div class="row bookHbsBottom">
        <SmartLink
          to={Urls.HbsFaqs}
          className={style.hbsStyleLink}
          isExternalLink={true} >
          <Content name="Frequently Asked Questions"/> <span className="ml-2">➔</span>
        </SmartLink>
      </div>
    </React.Fragment>
  ),
  buttonLabel: "Book an appointment"
};

export default QueryForHBS;
